import { SelectedCoverContext } from './Contexts';
import { useContext } from 'react';

export default function SelectedCover({
  children,
  ...htmlProps
}){ 

  const context = useContext(SelectedCoverContext);
  if( context && context.component ){
    return context.component;
  }

  let coverClass = "selected-item-cover";
  let outlineClass = "hover-outline absolute-cover";

  return (<div {...{
    ...(htmlProps||{}),
    objectType:"selected-cover",
  }} class={coverClass}>
    {children}
  </div>)
}

